import { useState, useEffect, useCallback } from "react";
import { onRateLimit } from "./rateLimitEmitter";

/**
 * Toast popup shown when a specific route is rate-limited (429 – endpoint spam).
 * Auto-dismisses after 5 seconds or on click.
 */
export default function RateLimitToast() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    return onRateLimit("route_block", () => {
      setVisible(true);
    });
  }, []);

  useEffect(() => {
    if (!visible) return;
    const id = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(id);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      onClick={() => setVisible(false)}
      className="fixed top-6 left-1/2 -translate-x-1/2 z-[9999] cursor-pointer animate-in fade-in slide-in-from-top-4 duration-300"
    >
      <div className="flex items-center gap-3 rounded-xl border border-amber-300 bg-amber-50 px-5 py-3 shadow-lg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 shrink-0 text-amber-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <div>
          <p className="text-sm font-semibold text-amber-900">
            Action trop fréquente
          </p>
          <p className="text-xs text-amber-700">
            Veuillez patienter 2 minutes avant de réessayer.
          </p>
        </div>
      </div>
    </div>
  );
}
